import { createApiClient } from '@mds/shared/lib/api';

export const api = createApiClient({
  baseUrl: import.meta.env.VITE_API_URL ?? '/api',
});
